import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerDichiarazioniIntentoAttiveModalComponent} from './worker-dichiarazioni-intento-attive-modal';

export const WorkerDichiarazioniIntentoAttiveModalModule: string = ng
    .module('worker-dichiarazioni-intento-attive-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerDichiarazioniIntentoAttiveModalComponent', WorkerDichiarazioniIntentoAttiveModalComponent)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-dichiarazioni-intento-attive-modal/worker-dichiarazioni-intento-attive-modal.module.ts